export const converterMixin = {
  methods: {
    convertToStatus (status) {
      switch (status) {
        case 0:
          return 'Формируется'
        case 1:
          return 'Сформирован'
        case 2:
          return 'Проверка'
        case 3:
          return 'Принят'
        case 4:
          return 'Отклонен'
        case 5:
          return 'Отправлен'
        case 6:
          return 'На портале'
        case 7:
          return 'Требуется проверка'
        case 8:
          return 'Требует ответа'
        case 9:
          return 'Входящий'
        case 93:
          return 'Уведомление о прибытии получено'
        case 94:
          return 'Принят ФТС'
        case 95:
          return 'Использован в ФТС'
        case 96:
          return 'Вручен должностному лицу ФТС'
        case 97:
          return 'Передан в ФТС'
        case 98:
          return 'Изменен'
        case 99:
          return 'Подтвержден'
        case 107:
          return 'Архивный'
        case 108:
          return 'Ожидает ответа'
        case 109:
          return 'Ожидает подписи'
        case 110:
          return 'Запрос на аннулирование'
        case 111:
          return 'Аннулирован'
        case 112:
          return 'Предварительное решение'
        case 113:
          return 'Решение'
        case 114:
          return 'Запрос статуса ПИ'
        case 118:
          return 'Решение по уточнённому пакету'
        case 119:
          return 'Отправка Запроса на аннулирование'
        case 120:
          return 'Уведомить о прибытии, изменений нет'
        case 121:
          return 'Уведомление о прибытии получено'
        case 122:
          return 'В листе ожидания прибытия судна'
        case 149:
          return 'Заявление зарегистрировано'
        case 150:
          return 'Разрешено уничтожение'
        case 151:
          return 'Не разрешено уничтожение'
        case 152:
          return 'Продлено уничтожение'
        case 153:
          return 'Акт зарегистрирован'
        case 154:
          return 'Уничтожен, снят с контроля'
        case 155:
          return 'Несоответствия в Акте'
        case 199:
          return 'Разрешение на выезд (ТОСЭР)'
        case 200:
          return 'Присвоен УИН'
        case 201:
          return 'Груз таможенный'
        case 209:
          return 'Разрешение на выезд (ПОЭЗ)'
        case 210:
          return 'Отправка описи'
        case 211:
          return 'Отправка документов'
        case 212:
          return 'Отказ в выдаче разрешения'
        case 213:
          return 'Разрешение на выезд'
        case 214:
          return 'Получен результат для СВХ'
        case 215:
          return 'Идентификация товаров'
        case 216:
          return 'Уведомление зарегистрировано'
        case 217:
          return 'Документы зарегистрированы в архиве'
        case 218:
          return 'Доставлено на пост'
        case 219:
          return 'Разрешение на въезд (ПОЭЗ)'
        case 220:
          return 'Оформление транзита'
        case 221:
          return 'Транзит оформлен'
        case 223:
          return 'Оформлена ДТ'
        case 266:
          return 'Решение по поручению на погрузку'
        case 272:
          return 'ПНП: Погрузка запрещена'
        case 273:
          return 'ПНП: Погрузка разрешена'
        case 274:
          return 'ПНП: Погрузка разрешена, подлежит таможенному контролю'
        case 275:
          return 'ПНП: Подлежит таможенному контролю'
        case 310:
          return 'Отказано в подписании таможней'
        case 311:
          return 'Подписано таможней'
        case 315:
          return 'Отказано в открытии транзита'
        case 320:
          return 'Открыт транзит'
        case 325:
          return 'Изменён транзит'
        case 330:
          return 'Недоставка товаров'
        case 335:
          return 'С оговорками закрыт транзит'
        case 340:
          return 'Закрыт транзит'
        case 341:
          return 'Документы получены'
        case 411:
          return 'ЭТД представлена в ФТС'
        case 412:
          return 'ЭТД: сообщить ИН инспектору'
        case 414:
          return 'ЭТД: ИН ожидает решения инспектора'
        case 416:
          return 'ЭТД подана инспектору'
        case 421:
          return 'ЭТД - отказ в регистрации'
        case 426:
          return 'ЭТД зарегистрирована'
        case 428:
          return 'ЭТД требуется окончательная ЭТД'
        case 429:
          return 'ЭТД: отправка окончательной ЭТД'
        case 430:
          return 'ЭТД: представлена окончательная ЭТД'
        case 436:
          return 'ЭТД: нет обеспечения'
        case 440:
          return 'ЭТД: просрочена предварительная ЭТД'
        case 441:
          return 'ЭТД: запрещен выпуск'
        case 442:
          return 'ЭТД: отправка отзыва ТД'
        case 443:
          return 'ЭТД отозвана'
        case 446:
          return 'ЭТД: выпуск разрешен'
        case 447:
          return 'ЭТД: бумажное оформление'
        case 450:
          return 'ЭТД: отправка о прибытии по ТД'
        case 451:
          return 'ЭТД: прибытие зарегистрировано'
        case 456:
          return 'ЭТД: завершён транзит'
        case 464:
          return 'ЭТД: отправка согласия на контроль'
        case 465:
          return 'ЭТД: требуется контроль'
        case 466:
          return 'ЭТД: контроль'
        case 467:
          return 'ЭТД: требуются операции'
        case 468:
          return 'ЭТД: отправка результата операций'
        case 469:
          return 'ЭТД: результат контроля'
        case 471:
          return 'ЭТД: перегрузка'
        case 473:
          return 'ЭТД: перепломбировка'
        case 475:
          return 'ЭТД: продление'
        case 476:
          return 'ТД аннулирована'
        case 477:
          return 'Бумажные документы получены'
      }
    },
    convertToDirection (to) {
      switch (to) {
        case 1:
          return 'Портал'
        case 2:
          return 'ФТС '
        case 52:
          return 'Опись для СВХ'
        case 55:
          return 'МПП 10226180 т/п Морской порт Калининград имени Н.С.Хазова'
        case 56:
          return 'МПП 10218040 т/п Усть-Лужский'
        case 57:
          return 'МПП 10317110 т/п Новороссийский юго-восточный'
        case 60:
          return 'ФТС - ЭД транзита (без предварительной ЭТД)'
        case 61:
          return 'ФТС - ЭД транзита - Отзыв декларации'
        case 62:
          return 'ФТС - ЭД транзита - Запрошенные документы'
        case 63:
          return 'Тестовый Портал «Морской порт»'
        case 64:
          return 'ФТС - ЭД транзита (с предварительной ЭТД)'
        case 65:
          return 'ОЭЗ/ПОЭЗ/ТОСЭР'
        case 66:
          return 'Лист ожидания прибытия судна'
      }
    },
    convertToStatusColor (status) {
      switch (status) {
        case 4:
        case 8:
        case 212:
        case 315:
        case 421:
        case 441:
          return 'danger'
        case 5:
        case 6:
        case 95:
        case 108:
        case 217:
        case 218:
          return 'warning'
        case 94:
        case 112:
        case 411:
        case 414:
        case 430:
          return 'success-light'
        case 98:
          return 'warning-dark'
        case 99:
        case 113:
        case 209:
        case 213:
        case 214:
        case 266:
        case 272:
        case 273:
        case 274:
        case 275:
        case 426:
        case 446:
          return 'success'
        case 107:
          return 'secondary'
        case 109:
          return 'primary'
        case 428:
        case 442:
        case 443:
          return 'danger-light'
        default:
          return 'secondary'
      }
    },
    convertToDirectionColor (to) {
      switch (to) {
        case 1:
          return 'secondary'
        case 2:
        case 60:
        case 61:
        case 62:
        case 64:
          return 'success'
        case 52:
        case 65:
          return 'warning'
        case 55:
        case 56:
        case 57:
        case 63:
        case 66:
          return 'info'
        default:
          return 'secondary'
      }
    }
  }
}
